// extracted by mini-css-extract-plugin
export default {"Footer":"style_Footer__msQs+"};